import { useTranslation } from 'react-i18next';

import { useConference } from '../../Dolby';
import { useMytaverseEvent } from '../../../../providers';

import { GetProgressStepTitleType } from './interfaces';

export const useCoreWeaveProgressBar = () => {
  const isConferenceInitialized = false;
  //const { isConferenceInitialized } = useConference();
  const { initMessageSended } = useMytaverseEvent();
  const { t: translate } = useTranslation();

  const secondStepLoading = false;
  const secondStepCompleted = true;
  const thirdStepLoading = !initMessageSended;
  const thirdStepCompleted = initMessageSended;
  const forthStepLoading = thirdStepCompleted && !isConferenceInitialized;
  const forthStepCompleted = thirdStepCompleted && isConferenceInitialized;

  const getProgressStepTitle: GetProgressStepTitleType = ({
    secondStepLoading,
    thirdStepLoading,
  }) => {
    if (secondStepLoading) {
      return 'loading.preparingWorld';
    }

    if (thirdStepLoading) {
      return 'loading.launchingExperience';
    }

    return 'loading.teleporting';
  };

  const title = getProgressStepTitle({
    secondStepLoading,
    thirdStepLoading,
  });

  return {
    secondStepLoading,
    secondStepCompleted,
    thirdStepLoading,
    thirdStepCompleted,
    forthStepLoading,
    forthStepCompleted,
    title: translate(title),
  };
};
